export function updateAthleteList(e) {
    const selectedActivity = e.currentTarget.textContent;
    const desktopNav = document.querySelector(".js--desktop-navigation-athlete");
    // const mobileNav = document.querySelector('.mobile-navigation-athlete');
    const activityListDesktop = desktopNav.querySelector(
        "#activity-list-athlete-parent"
    );
    // const activityListMobile = mobileNav.querySelector('#activity-list-athlete-parent');
    const activitiesDesktop = activityListDesktop.querySelectorAll(
        ".presentation .tab-link"
    );
    // const activitiesMobile = activityListMobile.querySelectorAll(".presentation .tab-link");
    const athletesContainer = document.getElementById("athlete-container");
    const athletes = athletesContainer.querySelectorAll("[data-activitytype]");
    const athletesSelected = athletesContainer.querySelectorAll(
        `[data-activitytype="${selectedActivity}"]`
    );
    // Update selected activity appearance
    activitiesDesktop.forEach((element) => element.classList.remove("active"));
    // activitiesMobile.forEach(element => element.classList.remove('active'));
    const index = Array.from(activitiesDesktop).findIndex(
        (activity) =>
            activity.textContent.toLowerCase() === selectedActivity.toLowerCase()
    );
    if (index !== -1) {
        activitiesDesktop[index].classList.add("active");
        // activitiesMobile[index].classList.add('active');
    }
    // Hide all athletes and show selected ones
    athletes.forEach((e) => e.classList.add("hidden"));
    athletesSelected.forEach((e) => e.classList.remove("hidden"));
    if (selectedActivity === "All Athletes") {
        athletes.forEach((e) => e.classList.remove("hidden"));
    }
}

/**
 * Initializes On Click Triggers for "athlete-tab-link" classes
 * @param {string} scope Gets the current Document
 * @returns Initializes On Click Triggers for all classes with "athlete-tab-link"
 */
export function initAthletesNavBar(scope = document) {
    const triggers = scope.querySelectorAll(".athlete-tab-link");

    triggers.forEach((trigger) => {
        if (trigger.dataset.athleteNavBar === "true") return;

        trigger.addEventListener("click", (e) => {
            e.preventDefault();
            updateAthleteList(e);
        });

        trigger.dataset.athleteNavBar = "true";
    });
}


document.addEventListener('DOMContentLoaded', () => {
    initAthletesNavBar();
});